<template>
  <Teleport to="body">
    <div v-if="open" class="sidebar-backdrop" @click="$emit('close')" />
  </Teleport>
  <aside :class="['sidebar', { 'sidebar--open': open }]">
    <div class="sidebar-logo">
      <img class="sidebar-logo-img" src="@/assets/ahrs-logo-light.png" alt="AHRS 2026 Admin" />
    </div>
    <div class="sidebar-section-label">Workspace</div>
    <button
      v-for="item in navItems"
      :key="item.key"
      :class="['nav-item', route === item.key ? 'active' : '']"
      @click="$emit('navigate', item.key)"
    >
      <component :is="item.icon" :size="18" />
      <span>{{ item.label }}</span>
      <span v-if="item.badge" class="badge-pill">{{ item.badge }}</span>
    </button>
    <div class="sidebar-foot">
      <div class="user-card">
        <div class="avatar">{{ initials }}</div>
        <div style="flex:1;min-width:0">
          <div class="user-name">{{ currentUser.name }}</div>
          <div class="user-role">{{ currentUser.email }}</div>
        </div>
        <button class="icon-btn" title="Sign out" aria-label="Sign out" @click="$emit('logout')">
          <IconLogOut :size="16" />
        </button>
      </div>
    </div>
  </aside>
</template>

<script>
import { IconDashboard, IconUsers, IconMap, IconCalendar, IconSettings, IconLogOut, IconBriefcase, IconActivity, IconBell } from '@/components/icons'

export default {
  name: 'AppSidebar',
  components: { IconDashboard, IconUsers, IconMap, IconCalendar, IconSettings, IconLogOut, IconBriefcase, IconActivity, IconBell },
  props: {
    route: { type: String, required: true },
    pendingTour: { type: Number, default: 0 },
    currentUser: { type: Object, required: true },
    open: { type: Boolean, default: false }
  },
  emits: ['navigate', 'logout', 'close'],
  computed: {
    initials() {
      return this.currentUser.name.split(' ').map(n => n[0]).join('')
    },
    navItems() {
      const items = [
        { key: 'dashboard', label: 'Dashboard', icon: IconDashboard },
        { key: 'summit', label: 'Summit Registrations', icon: IconUsers },
        { key: 'tour', label: 'Tour Registrations', icon: IconMap, badge: this.pendingTour || null },
        { key: 'sponsorship', label: 'Sponsorships', icon: IconBriefcase },
        { key: 'attendance', label: 'Attendance', icon: IconCalendar },
        { key: 'countdown', label: 'Countdown', icon: IconBell, adminOnly: true },
        { key: 'logs', label: 'Activity Log', icon: IconActivity, adminOnly: true },
        { key: 'settings', label: 'Settings', icon: IconSettings }
      ]
      const isAdmin = this.currentUser && this.currentUser.role === 'admin'
      return items.filter(i => !i.adminOnly || isAdmin)
    }
  }
}
</script>
